module.exports = __webpack_public_path__ + "static/bryan-co-logo-40c3892c219bb9e3d1698890fd53b9cb.jpg";